var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"tabindex":"0","role":"button","data-toggle":"popover","data-container":"body","data-content":`${_vm.content}`,"data-trigger":"focus","data-html":"true"}},[_c('span',{staticClass:"fas fa-info-circle",staticStyle:{"color":"#0073ad"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }